module.exports = __webpack_public_path__ + "static/media/medallaSilver.6f49c779.png";